//@flow
import React from 'react';
import {makeStyles, TableCell, TableRow} from '@material-ui/core';
import {
  VARIANT_TABLE_CELLS,
  FIXED_VARIANT_TABLE_CELLS,
} from '../../../constants';
import {colors} from '../../../../../assets/styles/colors';
import {useActiveCellsId} from '../../../utils';

const useStyles = makeStyles(theme => ({
  headerCell: {
    background: '#f4f4f699',
    whiteSpace: 'nowrap',
    padding: '0 1rem',
    height: '48px',

    '&:nth-of-type(odd)': {
      background: colors.grey200,
    },
  },
}));

export default function VariantTableHeader() {
  const classes = useStyles();
  const activeCellsId = useActiveCellsId();

  return (
    <TableRow>
      <TableCell />
      {VARIANT_TABLE_CELLS.filter(cell => {
        if (FIXED_VARIANT_TABLE_CELLS.includes(cell.id)) return true;
        return activeCellsId.includes(cell.id);
      }).map(({Header, id, HeaderLeftAdornment}) => (
        <TableCell key={id} className={classes.headerCell}>
          {typeof Header === 'string' ? Header : <Header />}
          {HeaderLeftAdornment && <HeaderLeftAdornment />}
        </TableCell>
      ))}
    </TableRow>
  );
}
